export const isGate = (device: Device) => {
  const deviceType = device?.type ?? null;
  return deviceType === 'CFC';
};